import React from 'react'
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';

export default function ContactMainSec() {
  return (
    <div className='contactsec__main'>

    <div className='contactsec__upper'>
    
    <h4 > GET IN TOUCH WITH US</h4>
    <div className='contactsec__line'/>
    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes.</p>
    
    </div>
    
    </div>



  )
}
